export default __webpack_public_path__ + "static/media/img12.2489f77e.jfif";